import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export const MultipleCalendarRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ spaceKey }: { spaceKey: any }): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				spaceKey: any;
			};
		};
		MainLayout: {
			spaceKey: any;
		};
	};
} = (): React.JSX.Element => {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.MULTIPLE_CALENDARS} />;
};

MultipleCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'multipleCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		spaceKey,
	},
});
